import SendIcon from "@mui/icons-material/Send";
import {
  Box,
  Button,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import { useIsMobile } from "../../../../hooks/useIsMobile";
import { toFullReadableAddress } from "../../../../utils";

import type { CompanyBasicDetails } from "components/CompanySetup/types";

interface ResultsTableRowProps {
  company: CompanyBasicDetails;
  onCompanySelected: (company: CompanyBasicDetails) => void;
}

export function CompanyResultsTableRow(props: ResultsTableRowProps) {
  const { company, onCompanySelected } = props;
  const isMobileLayout = useIsMobile({ maxWidth: 500 });
  const readableAddress = toFullReadableAddress(company.address?.[0]);

  return (
    <TableRow key={company.name}>
      <TableCell component="th" scope="row">
        <Stack
          direction={isMobileLayout ? "column" : "row"}
          justifyContent="space-between"
          alignItems="baseline"
        >
          <Box mr="1rem">
            <Stack direction="column" spacing={0.5}>
              <Typography variant="h5">{company.name}</Typography>
              {readableAddress && (
                <Typography variant="body2" color="text.secondary">
                  {readableAddress}
                </Typography>
              )}
            </Stack>
          </Box>
          <Box mt={isMobileLayout ? "1.5rem" : undefined}>
            <Button
              variant="outlined"
              onClick={() => onCompanySelected(company)}
              endIcon={<SendIcon />}
            >
              Send join request
            </Button>
          </Box>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
